import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { AdminMessage } from "../../_components";
import { BtnRound } from "../../_components/BtnRound";
import "../../assets/css/superAdmin.css";
import copyDark from "../../assets/images/copy-dark.png";
import copy from "../../assets/images/copy.png";
import Hospitals from "./hospitals";
import superiorDark from "./img/superior-dark.webp";
import superior from "./img/superior.webp";
import { PdpSuperAdmin } from "./index";

class SuperAdminPage_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: null,
      BtnList: [
        {
          img: copyDark,
          text: "کپی اطلاعات",
          onClick: (i) => this.setState({ currentPage: i }),
        },
        {
          img: superiorDark,
          text: "نیاز سنجی آموزشی",
          onClick: (i) => this.setState({ currentPage: i }),
        },
      ],
    };
  }

  componentDidMount = () => {
    if (localStorage.getItem("tokenSuperAdmin") === "undefined") {
      userActions.failure("کاربر گرامی ابتدا باید به حساب خود وارد شوید.");
      this.props.history.push(`/godAdmin`);
    }
    document.querySelector(".wave").classList.add("hidden");
  };

  componentDidUpdate = (props, state) => {
    const { currentPage } = this.state;
    if (state.currentPage !== currentPage) {
      this.setState({
        BtnList: [
          {
            img: currentPage === 0 ? copy : copyDark,
            text: "کپی اطلاعات",
            onClick: (i) => this.setState({ currentPage: i }),
          },
          {
            img: currentPage === 1 ? superior : superiorDark,
            text: "نیاز سنجی آموزشی",
            onClick: (i) => this.setState({ currentPage: i }),
          },
        ],
      });
    }
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  handleLogout = () => {
    this.props
      .dispatch(userActions.question("خروج", "آیا از خروج مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          localStorage.removeItem("tokenSuperAdmin");
          this.props.history.push("/godAdmin");
        }
      });
  };

  render() {
    const { handleLogout } = this;
    const { currentPage, BtnList } = this.state;
    return (
      <div className="container-fluid super-admin">
        <div className="container-fluid px-5">
          <div className="row my-1">
            <Navigation BtnList={BtnList} />
          </div>
        </div>
        <div className="container-fluid px-5">
          <div className="card bg-white shadow text-center border-0 position-relative">
            <div className="position-absolute logout-btn-bg" />
            <BtnRound
              className="position-absolute logout-btn logout-icon"
              onClick={handleLogout}
            />
            <AdminMessage
              text={`کاربر گرامی  به صفحه سوپر ادمین سامانه سنجاب خوش آمدید.`}
            />
          </div>
        </div>
        {currentPage === 0 && <Hospitals />}
        {currentPage === 1 && <PdpSuperAdmin />}
      </div>
    );
  }
}

class Navigation extends Component {
  render() {
    const { BtnList } = this.props;
    return (
      <div className="col-lg-12 indexSec">
        <div className="border-0 h-100 ">
          <RoundedBtnWrapper>
            {BtnList.map(({ img, text, onClick }, i) => (
              <RoundedBtn
                key={i}
                img={img}
                text={text}
                onClick={() => onClick(i)}
              />
            ))}
          </RoundedBtnWrapper>
        </div>
      </div>
    );
  }
}

class RoundedBtnWrapper extends Component {
  render() {
    return (
      <div
        className="card border-0"
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div className="card-body" style={{ height: "200px" }}>
          <div className="d-flex flex-wrap justify-content-center">
            <div className="card-deck">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

class RoundedBtn extends Component {
  render() {
    const { img, text, onClick } = this.props;
    return (
      <div
        className="card text-center border-0 "
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div
          className="card-body border-0 d-flex"
          style={{ padding: "1.25rem 0" }}
        >
          <div
            className="d-flex flex-column align-items-center indexs btn"
            onClick={onClick}
          >
            <img src={img} alt="" width="75" height="75" />
            <span
              className="iran-sans_Bold text-center text-dark my-2"
              style={{
                width: "100px",
                fontSize: "12px",
                paddingTop: "10px",
              }}
            >
              {text}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

const SuperAdminPage = connect((state) => ({
  globalStorage: state.globalStorage,
}))(SuperAdminPage_);

export { SuperAdminPage };
